export default __webpack_public_path__ + "media/images/tenant/timeline/step_4-0e6892a5803ecedb247ac982a2ca2ffe.jpg";